import { cn } from "../lib/utils";

export type LegalLinkItem = { href: string; label: string };

/**
 * The privacy policy and terms of service links under a sign-in screen
 * (P12-T21). The pages live on the product site; the caller passes nothing
 * while they are not published, and nothing is drawn.
 */
export function LegalLinks({
	links,
	className,
}: {
	links: readonly LegalLinkItem[] | null;
	className?: string;
}) {
	if (!links || links.length === 0) return null;
	return (
		<p className={cn("flex gap-4 text-muted-foreground text-xs", className)}>
			{links.map((link) => (
				<a
					key={link.href}
					href={link.href}
					target="_blank"
					rel="noopener"
					className="underline underline-offset-2 hover:text-foreground"
				>
					{link.label}
				</a>
			))}
		</p>
	);
}
